/**
 * src/components/header/Header.js
 *
 * Componente padre del header. Orquesta logo, navegación, CTA y menú móvil.
 * Los datos se obtienen de la base de datos local (header.db.js).
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { signal, effect } from '@core/signal.js'
import { headerData } from '@/db/header.db.js'

define('Header', () => {
    const isOpen   = signal(false)
    const onToggle = () => isOpen.set(!isOpen.get())

    // Drawer de navegación para móvil
    const drawer = h('div', { className: 'nav-drawer' },
        c('NavLinks', { links: headerData.navLinks }),
        c('NavCTA',   headerData.cta)
    )

    // Cerrar drawer al hacer clic fuera de él
    document.addEventListener('click', e => {
        if (isOpen.get() && !header.contains(e.target)) {
            isOpen.set(false)
        }
    })

    // Cerrar drawer al cambiar de ruta
    window.addEventListener('popstate', () => isOpen.set(false))

    // Sincronizar estado del drawer con la señal
    effect(() => {
        drawer.classList.toggle('nav-drawer--open', isOpen.get())
        document.body.classList.toggle('no-scroll', isOpen.get())
    })

    const header = h('header', { className: 'site-header' },
        h('div', { className: 'site-header__inner' },
            c('NavLogo',   headerData.logo),
            c('NavLinks',  { links: headerData.navLinks }),
            h('div', { className: 'site-header__actions' },
                c('NavCTA',    headerData.cta),
                c('NavToggle', { isOpen, onToggle })
            )
        ),
        drawer
    )

    return header
})
